export default function StakeForOptionIcon() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.80671 2.46809C4.86261 2.46809 2.47596 4.85467 2.47596 7.79871V24.2005C2.47596 27.1445 4.86261 29.5311 7.80671 29.5311H24.2089C27.153 29.5311 29.5397 27.1445 29.5397 24.2005V7.79871C29.5397 4.85467 27.153 2.46809 24.2089 2.46809H7.80671ZM0.015625 7.79871C0.015625 3.4959 3.5038 0.0078125 7.80671 0.0078125H24.2089C28.5118 0.0078125 32 3.4959 32 7.79871V24.2005C32 28.5033 28.5118 31.9914 24.2089 31.9914H7.80671C3.5038 31.9914 0.015625 28.5033 0.015625 24.2005V7.79871Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.1355 9.69608C20.6679 10.1183 20.7571 10.8921 20.3349 11.4244L13.4787 20.0681C13.0811 20.5695 12.3652 20.6822 11.8326 20.3272L7.42031 17.3857L2.20115 24.0939C1.78396 24.63 1.01105 24.7266 0.474829 24.3094C-0.0613972 23.8922 -0.157892 23.1193 0.259303 22.5831L6.18049 14.9727C6.57621 14.464 7.29749 14.347 7.83374 14.7045L12.255 17.6519L18.4073 9.89546C18.8295 9.36316 19.6033 9.2739 20.1355 9.69608Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.6621 10.4489C13.6621 9.76946 14.2128 9.21875 14.8923 9.21875H20.0753C20.7548 9.21875 21.3055 9.76946 21.3055 10.4489V15.6155C21.3055 16.2948 20.7548 16.8456 20.0753 16.8456C19.396 16.8456 18.8452 16.2948 18.8452 15.6155V11.679H14.8923C14.2128 11.679 13.6621 11.1282 13.6621 10.4489Z"
        fill="currentColor"
      />
    </svg>
  );
}
